export default "__VITE_ASSET__CD2P$V01__$_?inline__"